module.exports = __webpack_public_path__ + "static/manage-ff225f81f99c82ac711abfbb8a9acb8b.mp4";